import { render, staticRenderFns } from "./LogView.vue?vue&type=template&id=a3b2aad6&scoped=true&"
import script from "./LogView.vue?vue&type=script&lang=js&"
export * from "./LogView.vue?vue&type=script&lang=js&"
import style0 from "./LogView.vue?vue&type=style&index=0&id=a3b2aad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b2aad6",
  null
  
)

/* custom blocks */
import block0 from "./LogView.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports